
import { mapState, mapActions, mapMutations } from "vuex";
import ConfirmationDialog from "../dialogs/confirmation-dialog.vue";
import MenuOverlappingBrandAvatars from "./menu-overlapping-brand-avatars.vue";
import CurrencyConverter from "../common/currency-converter.vue";
import menuItemImage from "~/assets/images/menuItemImage.svg";

export default {
  components: {
    ConfirmationDialog,
    MenuOverlappingBrandAvatars,
    CurrencyConverter
  },
  props: {
    menuItem: {},
    showPrice: {
      type: Boolean,
      default: true
    },
    showSwitch: {
      type: Boolean,
      default: true
    },
    highlightText: {
      type: String,
      default: ""
    },
    showOverLappingBrandAvatars: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false,
      variants: [],
      loading: false,
      showTurnoffConfirmationDialog: false,
      combosToBeTurnedOff: [],
      radioGroup: 1,
      selectedItem: {},
      hasDisplayedConfirmation: false,
      menuItemImage
    };
  },
  computed: {
    ...mapState("menu", ["combosList"]),
    getName() {
      if (this.highlightText) {
        return this.getHighlightedText(
          this.menuItem.item_name,
          this.highlightText
        );
      } else {
        return this.menuItem.item_name || this.menuItem.name;
      }
    },
    hasVariant() {
      return (
        this.menuItem &&
        this.menuItem.variants &&
        this.menuItem.variants.items &&
        this.menuItem.variants.items.length
      );
    },
    isMenuItemStatusActive() {
      return this.menuItem.item_is_active == 1;
    },
    isAllVariantsDisabled() {
      return this.hasVariant
        ? !this.menuItem.variants.items.find((variant) => {
            return variant.is_active;
          })
        : false;
    }
  },

  mounted() {
    this.syncActivestate();
  },
  watch: {
    menuItem: {
      handler(val) {
        this.syncActivestate();
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("menu", [
      "getMenuList",
      "getMenuItem",
      "changeMenuItemStatus",
      "changeVariantItemStatus",
      "changeComboItemStatus"
    ]),
    ...mapMutations("menu", [
      "SET_MENU_ITEM_ACTIVE_STATUS",
      "SET_MENU_ITEM_IN_LIST"
    ]),
    syncActivestate() {
      this.isActive = this.isMenuItemStatusActive;
      this.setVariants();
    },
    setVariants() {
      this.variants = [];
      if (this.hasVariant) {
        // this.variants = JSON.parse(
        //   JSON.stringify(this.menuItem.variants.items)
        // );
        this.variants = this.menuItem.variants.items.map((el) => {
          return {
            id: el.id,
            name: el.name,
            description: el.description,
            price: el.price,
            is_active: el.is_active && this.isActive && true,
            loading: false
          };
        });
      }
    },
    /**
     * called when the On-Off switch is toggled
     */
    handleMenuItemSwitchToggle(status) {
      if (!status) {
        if (this.hasVariant) {
          this.combosToBeTurnedOff = this.findCombos(
            this.combosList,
            this.menuItem,
            this.menuItem.variants.items
          );
        } else {
          this.combosToBeTurnedOff = this.findCombos(
            this.combosList,
            this.menuItem
          );
        }

        if (this.combosToBeTurnedOff.length > 0) {
          this.showTurnoffConfirmationDialog = true;
        } else {
          this.handleChangeMenuItemStatus(this.menuItem.id, this.isActive);
        }
      } else {
        this.handleChangeMenuItemStatus(this.menuItem.id, this.isActive);
      }
    },

    async handleChangeMenuItemStatus(itemId, status, shouldTurnOffCombo) {
      this.loading = true;

      try {
        await this.changeMenuItemStatus({ itemId, status, shouldTurnOffCombo });
        if (this.hasVariant) {
          const { data } = await this.getMenuItem(this.menuItem.id);
          this.SET_MENU_ITEM_IN_LIST(data);
        } else {
          this.SET_MENU_ITEM_ACTIVE_STATUS({ itemId, status: status ? 1 : 0 });
        }
      } catch (error) {
        this.isActive = !this.isActive;
        this.$nuxt.$emit("show-error-toast", error);
      }
      this.loading = false;
    },
    /**
     * method to turnoff the combos consisiting the menu item
     */

    handleTurnoffAction() {
      this.showTurnoffConfirmationDialog = false;

      if (this.selectedItem.variantId) {
        this.handleChangeVariantItemStatus(
          this.selectedItem.itemId,
          this.selectedItem.variantId,
          this.selectedItem.status,
          this.selectedItem.index,
          this.selectedItem.variant
        );
      } else {
        this.handleChangeMenuItemStatus(
          this.menuItem.id,
          this.isActive,
          this.radioGroup !== 1
        );
      }
      this.hasDisplayedConfirmation = false;
    },
    handleCancelAction() {
      if (this.selectedItem.variantId) {
        this.selectedItem.variant.is_active = true;
      } else {
        this.isActive = true;
      }
      this.showTurnoffConfirmationDialog = false;
      this.hasDisplayedConfirmation = false;
    },

    handleChangeVariantItemStatus(itemId, variantId, status, index, variant) {
      this.selectedItem = { itemId, variantId, status, index, variant };
      if (this.isMenuItemStatusActive) {
        const activeVariants = this.menuItem.variants.items.filter(
          (variant) => {
            return variant.is_active;
          }
        );
        if (!status && !this.hasDisplayedConfirmation) {
          this.combosToBeTurnedOff = this.findCombos(this.combosList, variant);
          if (this.combosToBeTurnedOff.length > 0) {
            this.showTurnoffConfirmationDialog = true;
            this.hasDisplayedConfirmation = true;
            return;
          }
        }
        if (!status && activeVariants && activeVariants.length == 1) {
          this.$nuxt.$emit(
            "show-error-toast",
            "Please turn off the item instead, since the item will be left with no variants."
          );
          setTimeout(
            (() => {
              this.setVariants();
            }).bind(this),
            300
          );
          this.selectedItem = {};
          return;
        }
        this.saveVariantItemStatus({
          ...this.selectedItem,
          shouldTurnOffCombo: this.radioGroup !== 1
        });
      }
    },
    saveVariantItemStatus({
      itemId,
      variantId,
      status,
      index,
      shouldTurnOffCombo
    }) {
      this.variants[index].loading = true;
      this.changeVariantItemStatus({
        itemId,
        variantId,
        status,
        shouldTurnOffCombo
      })
        .then(async (response) => {
          this.selectedItem = {};
          if (response.status === 200) {
            this.SET_MENU_ITEM_ACTIVE_STATUS({
              itemId,
              variantId,
              status
            });
          } else {
            this.variants[index].is_active = !this.variants[index].is_active;
            this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
          this.variants[index].is_active = !this.variants[index].is_active;
        })
        .finally(() => {
          this.variants[index].loading = false;
          this.selectedItem = {};
        });
    }
  }
};
